import { render, staticRenderFns } from "./OrderReminder.vue?vue&type=template&id=c24974c6&"
import script from "./OrderReminder.vue?vue&type=script&lang=js&"
export * from "./OrderReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports